export default function FieldError({message}) {
    return (
        <div className={"!text-[14px] !leading-[20px] font-bold text-red"}>
            {message}
        </div>
    )
}
